

precision highp float;
precision highp sampler2D;

in float position;

uniform sampler2D rttTexture;
uniform sampler2D rttTexturePrev;
uniform float rttSize;
uniform float screenSize;

uniform float extrapolationFactor;
uniform float renderStepSize;
uniform bool fastIsLarger;

out float speed;

float factor = 1.;

vec4 advance(float position_) {
  if (position_ > (DENSITY / 1000.0) * screenSize * screenSize) {
    speed = 0.0;
    return vec4(0.0);
  }

  float x = fract(position_ / rttSize);
  float y = floor(position_ / rttSize) / rttSize;

  vec4 color = texture(rttTexture, vec2(x, y));
  vec2 pos = color.ba + color.rg / 255.0;

  vec4 colorPrev = texture(rttTexturePrev, vec2(x, y));
  vec2 posPrev = colorPrev.ba + colorPrev.rg / 255.0;

  vec2 diff = pos - posPrev;
  pos += diff * extrapolationFactor;

  speed =
    renderStepSize *
    step(0.0001, dot(posPrev, posPrev)) * // ignore initial zero
    length(diff * screenSize);

  return vec4(pos, diff);
}

void main() {
  vec4 posdiff = advance(position);

  // gl_PointSize = SIZE;
  gl_PointSize = fastIsLarger ? (SIZE + SIZE * log(speed + 1.)) / 2. : SIZE;
  // gl_PointSize = (SIZE + SIZE * log(speed + 1.)) / 2.;
  gl_Position =
    vec4(2.0*posdiff.x-1.0,-(2.0*posdiff.y-1.0),0.,1.);
}
